module.exports = {
	"hello": "Hallo, Welt!",
	"Größe": "Maße",
	"min_order_value": "Mindestbestellwert",
	"min_order_value_ok": "Mindestbestellwert erreicht",
	"availability": {
		"soon": "aktuell nicht auf Lager. Bestellen Sie jetzt und wir nehmen den Artikel in Rückstand.",
		"available": "verfügbar"
	},
	"billing address": "Rechnungsanschrift",
	"delivery address": "Lieferanschrift",
	"payment": "Zahlung",
	"your message": "Ihre Mitteilung",
	"delivery": "Lieferung",
	"product": {
		"availability": "Verfügbarkeit",
		"deliverable": "Lieferbarkeit",
		"articlenr": "Art-Nr.",
		"popularity": "Beliebtheit",
		"price": "Preis",
		"single_price": "Einzelpreis",
		"label": "Bezeichnung",
		"sum": "Summe",
		"amount": "Stück",
		"piece": "Stück"
	},
	"address": {
		"address": "Adresse",
		"salutation": "Anrede",
		"company": "Firma",
		"surname": "Nachname",
		"street": "Straße",
		"invoice": "Rechnungsadresse",
		"addition": "Adresszusatz",
		"pcode": "PLZ",
		"country": "Land",
		"city": "Ort",
		"first_name": "Vorname",
		"delivery_address": "Lieferadresse"
	},
	"products": {
		"search": "Suche (Art.Nr., EAN, Name)"
	},
	"orderlist": {
		"add": "merken",
		"added": "gemerkt",
		"on_orderlist": "merken",
		"all_lists": "Alle Listen"
	},
	"csv": {
		"uploadFile": "Datei hochladen"
	},
	"category": {
		"from_this_category": "Aus dieser Kategorie",
		"last_viewed": "Zuletzt angesehen"
	},
	"shop": {
		"VE": "VE",
		"login": "Login",
		"register": "Neu Registrieren",
		"lost_password": "Password vergessen?",
		"create": "Erstellen",
		"user": "Benutzer",
		"password": "Passwort",
		"please_login_for_product_details": "Melden Sie sich an, um weitere Produktdetails zu sehen.",
		"finalize_order": "Zahlungspflichtig bestellen",
		"continue_shopping": "Weiter einkaufen",
		"check_and_confirm": "Prüfen und Bestätigen",
		"navigate_to_checkout": "Zur Kasse",
		"sort": "Sortieren",
		"deliverable": "Lieferbar",
		"article": "Artikel",
		"articles_per_site": "Artikel pro Seite",
		"to_top": "zum Seitenanfang",
		"add_all_products": "Alle Produkte hinzufügen",
		"add": "Hinzufügen",
		"select": "Auswählen",
		"close": "Schließen",
		"open": "Öffnen",
		"selected": "Ausgewählt",
		"delete": "Löschen",
		"list": "Liste",
		"back": "Zurück",
		"comment": "Kommentar",
		"add_new_address": "Neue Adresse eingeben",
		"AGB_DELIVERY_INFO": "AGB und Versandinformationen",
		"CONFIRM_AGB_DELIVERY_INFO": "AGB und Versandinformationen bestätigt",
		"continue": "Weiter"
	},
	"cart": {
		"your_comment": "Ihr Kommentar",
		"cart": "Warenkorb",
		"positions": "Positionen",
		"piece": "Stück",
		"subtotal": "Zwischensumme",
		"address": "Adresse",
		"check_and_submit": "Prüfen und Bestätigen"
	},
	"nav": {
		"account": "Konto",
		"logout": "Abmelden",
		"quickorder": "Direktbestellung",
		"service": "Service",
		"privacy": "Datenschutz",
		"menu": "Menü",
		"orderlist": "Merkliste"
	},
	"message": {
		"min_order_value": "Sie haben den Mindestbestellwert (%{value} EUR) noch nicht erreicht",
		"empty_cart": "Sie haben keine Produkte im Warenkorb"
	},
	"misc": {
		"price_a_piece": "Stückpreis"
	},
	"footer": {
		"delivery": "Versandkosten",
		"imprint": "Impressum",
		"contact": "Kontakt",
		"request_catalogue": "Katalog anfordern",
		"new_client": "Neukundenanmeldung",
		"change_address": "Adressänderung",
		"AGB": "AGB"
	},
	"reset": {
		"reset": "Passwort zurücksetzen",
		"your_mail": "Ihre bei uns registrierte E-Mail",
		"back": "Zurück",
		"choose_password": "Passwort wählen",
		"your_new_password": "Ihr neues Passwort",
		"repeat_password": "Passwort wiederholen",
		"set_password": "Passwort setzen",
		"too_short": "Passwort zu kurz",
		"too_short_explained": "Bitte wählen Sie ein längeres Passwort",
		"passwords_not_equal": "Passwörter stimmen nicht überein",
		"passwords_not_equal_explained": "Sie haben verschiedene Passwörter eingegeben",
		"success": "Passwort zurückgesetzt",
		"success_explained": "Wir haben Informationen zu Ihrem Passwort an ihre E-Mail (%{email}) gesendet.",
		"success_explained_long": "Ihrem Wunsch entsprechend, haben wir Ihr Passwort erfolgreich zurückgesetzt. Um den Vorgang abzuschließen folgen Sie den Anweisungen in unserer Passwort-Reset E-Mail.",
		"mail_not_found": "E-Mail nicht gefunden",
		"mail_not_found_explained": "Die von Ihnen eingegebene E-Mail Adresse konnte nicht gefunden werden konnte. Bitte setzen Sie sich mit dem Innendienst in Verbindung. "
	},
	"strings": {
		"new_account_hint": "Sie haben noch kein Konto?",
		"new_account_action": "Neukundenanmeldung für Ersteinkäufer",
		"new_account_enabled": "Freischaltung für Bestandskunden"
	},
	"error": {
		"login_error": "Ungültige Anmeldedaten"
	},
	"brand_not_avail": "Leider ist diese Marke in ihrem Land nicht verfügbar"
};


//////////////////
// WEBPACK FOOTER
// ./src/locales/de.json
// module id = 833
// module chunks = 0